import * as React from "react";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faIdCard, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { ErrorMessage } from "@hookform/error-message";
import _ from "lodash/fp";
import { useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
const axios = require('axios');
// console.log(process.env.REACT_APP_HOST_TYPE)
if (process.env.REACT_APP_HOST_TYPE !== 'production') {
  require('dotenv').config();
}
const SearchForm = () => {
  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all"
  });
  const [isButtonLoading, setIsButtonLoading] = React.useState(false);
  let history = useHistory()
  let url = "/dmv/dls-status-check/lookup.cgi"
      const onSubmit =  (data) => {
      // history.push({pathname:'/results', state:{data:data}});
      const params = new URLSearchParams();
      params.append('dln', data.dln);
      if(process.env.REACT_APP_HOST_TYPE == "local"){
        url ="http://localhost:4000"
      }
      axios.post(url, params)
      .then(function (response) {
        // console.log(response);
         history.push({
          pathname:'/results', state:{data:response.data}
        });
      })
      .catch(function (error) {});
    };
    
    return (
      <form className="flex flex-col justify-items-center items-center" onSubmit={handleSubmit(onSubmit)}>
        <FontAwesomeIcon icon={faIdCard} size="6x" className=" mt-5 text-blue-600 dark:text-white" aria-hidden="true" />
        <ErrorMessage
        errors={errors}
        name="dln"
        render={({ messages }) => {
            setIsButtonLoading(false);
          return messages
            ? _.entries(messages).map(([type, message]: [string, string]) => (
              <span className="flex flex-row">
                <FontAwesomeIcon icon={faExclamationTriangle} className=" self-center text-red-600 dark:text-white" aria-hidden="true" />
                <p className="self-center py-2 px-3 text-red-600 sm:text-sm dark:text-white" 
                key={type}>{message}</p>
              </span>
              ))
            : null;
        }}
      />

        <input
        className="mt-9 block w-3/4 border border-gray-300 rounded-md shadow-sm py-2 px-3 text-black sm:text-sm"
        autoComplete="off"
        maxLength="9"
        placeholder="Enter license/ID number"
        {...register("dln", {
          required: "This input is required.",
          pattern: {
            value: /^[A-Z]\d{8}$/,
            message: "Please input a valid license number beginning with a capital letter"
          },
          minLength: {
            value: 9,
            message: "Please input a valid 9 digit license number"
          },
          maxlength: {
            value:10,
            message: "Please input a valid 9 digit license number"
          }
        })}
      />
        <hr className="mt-3 w-3/4"/>
          <Button
              className={"mt-5 text-center w-3/4 px-3 py-3 font-large rounded-md shadow-sm text-white bg-gradient-to-r from-blue-600 to-blue-900 hover:from-blue-700 hover:to-blue-900"}
              type={"submit"}
              onClick={() => {
                  setIsButtonLoading(true);
                  setTimeout(() => {
                      setIsButtonLoading(false);
                  }, 60000);
              }}
              isLoading={isButtonLoading}
          >
              Search License Status
          </Button>
      </form>
    );
};

function Button({ isLoading, children, ...props }) {
    return (
        <button className="button" {...props}>
            {isLoading ?
                <Loader type="Bars" color="White" width="100%" height="1.5em"/>
                : children}
        </button>
    );
}
export default SearchForm;
